import React from 'react';
import { DatoCmsApiImage } from '../../../schema/datocms/blocks/api-image';

export interface ApiImageProps {
    apiImage: DatoCmsApiImage;
    isStyled?: boolean;
}


const ApiImageComponent =  ( {apiImage, isStyled,  ...rest}: React.PropsWithChildren<ApiImageProps> & React.HTMLAttributes<Element>): React.ReactElement => {
    let url: string | undefined = undefined;
    let altText: string | undefined = undefined;
    if(apiImage) {
        altText = apiImage.image.alt;
        url = apiImage.image.url;

        url += apiImage.padding? `&pad=${apiImage.padding}` : '';
        url += apiImage.padRight? `&pad-right=${apiImage.padRight}` : '';
        url += apiImage.padLeft? `&pad-left=${apiImage.padLeft}` : '';
        url += apiImage.padTop? `&pad-top=${apiImage.padTop}` : '';
        url += apiImage.padBottom? `&pad-bottom=${apiImage.padBottom}` : '';
        url += ( apiImage.padding || apiImage.padRight || apiImage.padLeft || apiImage.padTop || apiImage.padBottom ) && apiImage.backgroundColor ? `&bg=${apiImage.backgroundColor}` : '';
        url += apiImage.imageHeight ? `&h=${apiImage.imageHeight}` : '';
        url += apiImage.imageWidth ? `&w=${apiImage.imageWidth}`: '';
        url += apiImage.outputQuality ? `&q=${apiImage.outputQuality}`: '';
        const cropConfig: string [] = [];
        let crop = '';

        if(apiImage.cropBottom || apiImage.cropTop || apiImage.cropLeft || apiImage.cropRight) {
            if(apiImage.cropBottom) {
                cropConfig.push('bottom');
            }
            if(apiImage.cropTop) {
                cropConfig.push('top');
            }
            if(apiImage.cropLeft) {
                cropConfig.push('left');
            }
            if(apiImage.cropRight) {
                cropConfig.push('right');
            }
            crop = `&crop=${cropConfig.join(',')}&fit=crop`;
        }
        url += crop;
    }

    if(isStyled){
        // return a div element styled with the api-image set as a background image
        if(rest.style) {
            rest.style.backgroundImage = `url("${url}")`;
        } else {
            rest.style = {
                backgroundImage: `url("${url}")`
            };
        }

        return <div {...rest}></div>;
    }

    return (<img src={url} alt={altText} {...rest} />);
};

export default ApiImageComponent;
